module.exports = __webpack_public_path__ + "static/content-pts-3cc37352af46743d95694a432b8c5dce.jpg";